import React, { useEffect, useState } from "react";
import { Box, Heading, Alert, AlertIcon, useToast } from "@chakra-ui/react";
import { useParams, useNavigate } from "react-router-dom";
import CandidatureForm from "./CandidatureForm";
import { useCandidature } from "../../hooks/useCandidature";

const CandidaturePage: React.FC = () => {
    const { id: missionId } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const { postulerMission } = useCandidature();
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);
    const toast = useToast();

    const handleSubmit = async (cvFile: File) => {
        if (!missionId) {
            setError("Mission non spécifiée");
            return;
        }
        console.log("[CandidaturePage] appel postulerMission avec", {
            missionId,
            cvFile: { name: cvFile.name, size: cvFile.size }
        });

        try {
            const result = await postulerMission(missionId, cvFile);
            if (result) {
                setSuccess(true);
                setError(null);
                toast({
                    title: "Candidature envoyée avec succès !",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                });
            } else {
                setError("Erreur lors de l'envoi de la candidature.");
            }
        } catch (err) {
            const errorMessage = (err as Error).message || "Une erreur est survenue.";
            setError(errorMessage);
            setSuccess(false);
        }
    };

    useEffect(() => {
        let timer: NodeJS.Timeout;
        if (success) {
            timer = setTimeout(() => navigate("/mescandidatures"), 2000);
        }
        return () => clearTimeout(timer);
    }, [success, navigate]);

    if (!missionId) {
        return (
            <Box p={6}>
                <Alert status="error">
                    <AlertIcon />
                    Mission non spécifiée.
                </Alert>
            </Box>
        );
    }

    return (
        <Box p={6}>
            <Heading as="h1" mb={6}>
                Postuler à la Mission
            </Heading>
            {error && (
                <Alert status="error" mb={4}>
                    <AlertIcon />
                    {error}
                </Alert>
            )}
            <CandidatureForm onSubmit={handleSubmit} />
        </Box>
    );
};

export default CandidaturePage;